'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes');

var FormActionCreators = {
  submitForm() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SUBMIT_FORM
    });
  },

  resetForm() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESET_FORM
    });
  },

  showMessages(messages) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.SHOW_FORM_MESSAGES,
      messages: messages
    });
  },

  valueChanged(key, value) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.FORM_VALUE_CHANGED,
      key: key,
      value: value
    });
  }
};

module.exports = FormActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/FormActionCreators.js
 **/